import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Store from "./redux/store";
import { getAllProducts } from "./redux/actions/product";
import { getCategories } from "./redux/actions/category";
import { getSubcategories } from "./redux/actions/Subcategory";
import { getSubSubcategories } from "./redux/actions/subsubcategory";
import { getFilters } from "./redux/actions/filters";
import { loadAdmin } from "./redux/actions/admin.js";
import { ToastProvider } from "./components/Layout/Toast/ToastProvider";
import AdminProtectedRoute from "./routes/AdminProtectedRoute";

import {
  HomePage,
  ProductPage,
  SubProductPage,
  ProductListPage,
  SubListPage,
  SsubListPage,
  TermsPage,
  PolicyPage,
} from "./routes/Routes";

import {
  AdminLoginPage,
  AdminDashPage,
  AdminCreateProduct,
  AdminCategory,
  AdminFiltersPage,
  AdminAllProducts,
  AdminParentColors,
  AdminColors
} from "./routes/AdminRoutes";

import "./App.css";

function App() {
  useEffect(() => {
    Store.dispatch(getAllProducts());
    Store.dispatch(getCategories());
    Store.dispatch(getSubcategories());
    Store.dispatch(getSubSubcategories());
    Store.dispatch(getFilters());
    Store.dispatch(loadAdmin());
  }, []);

  return (
    <ToastProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* Product Pages */}
          <Route path="/product/:id" element={<ProductPage />} />
          <Route
            path="/subproduct/:subProductId"
            element={<SubProductPage />}
          />
          {/* Lists Pages */}
          <Route path="/products/:categoryId" element={<ProductListPage />} />
          <Route path="/productss/:subCategoryId" element={<SubListPage />} />
          <Route path="/items/:subSubCategoryId" element={<SsubListPage />} />
          {/* Admin Pages */}
          <Route path="/login/admin/i/secret" element={<AdminLoginPage />} />
          <Route
            path="/dashboard"
            element={
              <AdminProtectedRoute>
                <AdminDashPage />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/dashboard-create-product"
            element={
              <AdminProtectedRoute>
                <AdminCreateProduct />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/dashboard-create-category"
            element={
              <AdminProtectedRoute>
                <AdminCategory />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/dashboard-filters"
            element={
              <AdminProtectedRoute>
                <AdminFiltersPage />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/dashboard-products"
            element={
              <AdminProtectedRoute>
                <AdminAllProducts />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/dashboard-parentcolors"
            element={
              <AdminProtectedRoute>
                <AdminParentColors />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/dashboard-colors"
            element={
              <AdminProtectedRoute>
                <AdminColors />
              </AdminProtectedRoute>
            }
          />

          {/* Other Pages */}
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/policy" element={<PolicyPage />} />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
